import { clsx } from 'clsx';
import React from 'react';

import * as styles from './ListingTile.css';

// DetailLabel component that handles textAlign prop
interface DetailLabelProps {
  textAlign?: 'left' | 'center' | 'right';
  children: React.ReactNode;
  className?: string;
}

export const DetailLabel: React.FC<DetailLabelProps> = ({
  textAlign = 'left',
  children,
  className,
}) => (
  <span
    className={clsx(
      styles.detailLabel,
      styles.detailLabelTextAlign[textAlign],
      className
    )}
  >
    {children}
  </span>
);

// DetailValue component that handles textAlign prop
interface DetailValueProps {
  textAlign?: 'left' | 'center' | 'right';
  children: React.ReactNode;
  className?: string;
}

export const DetailValue: React.FC<DetailValueProps> = ({
  textAlign = 'left',
  children,
  className,
}) => (
  <span
    className={clsx(
      styles.detailValue,
      styles.detailValueTextAlign[textAlign],
      className
    )}
  >
    {children}
  </span>
);

// Simple components
export const ListingTilesContainer: React.FC<{
  children: React.ReactNode;
  className?: string;
}> = ({ children, className }) => <div className={className}>{children}</div>;

export const CheckboxContainer: React.FC<{
  children: React.ReactNode;
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
}> = ({ children, className, onClick }) => (
  <div className={clsx(styles.checkboxContainer, className)} onClick={onClick}>
    {children}
  </div>
);

export const Divider: React.FC<{ className?: string }> = ({ className }) => (
  <div className={clsx(styles.divider, className)} />
);

export const DetailUnitCostValue: React.FC<{
  children: React.ReactNode;
  className?: string;
}> = ({ children, className }) => (
  <span className={clsx(styles.detailUnitCostValue, className)}>
    {children}
  </span>
);
